import React, {useCallback, useEffect, useRef, useState} from 'react';
import s from './styles.module.css'
import Header from "../../components/header";
import classNames from "classnames";
import ModalElement from "./modal";
import api from "../../api";
import Empty from "../../components/empty";
import {Box, Button, Modal} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CheckIcon from "@mui/icons-material/Check";

const Synch = ({
                   data,
                   setData,
                   newData,
                   setNewData,
                   setPage,
                   confirm,
                   status,
                   token,
                   headerData
               }) => {
    const [openModal, setOpenModal] = useState(false)
    const greenRef = useRef(null);
    const yellowRef = useRef(null);
    const redRef = useRef(null);

    const total = data?.reduce((acc, curr) => {
        return acc += +curr?.value
    }, 0)

    const handlerClick = async (id, value, synchro_type_id, divider) => {
        try {
            const newValue = data.find(el => el.score_synchro_id === id)?.value;
            const sumNewValue = (newValue ? newValue : 0) + value;

            let divide;
            if (synchro_type_id === 1)      divide = 0.1;
            else if (synchro_type_id === 2) divide = 0.5;
            else if (synchro_type_id === 3) divide = 3;
            else divide = 1;

            const result = Math.round(sumNewValue / divide);

            api().post(`coach/synchro/send/${synchro_type_id}/${result}/${token}`)
            setData(data.map((el) => el.score_synchro_id === id ? ({...el, value: el.value + value}) : el))
            if (synchro_type_id === 3) {
                let title = "Метка от STC";
                fetch(`${process.env.REACT_APP_VIDEO_MODULE_FIRST}/api/video/add-marker`, {
                    method: 'POST',
                    headers: {'Content-Type': 'application/x-www-form-urlencoded'},
                    body: new URLSearchParams({title})
                }).catch(err => {
                    console.log("Не удалось отправить мтеку: " + err);
                })
            }
        } catch (e) {
            console.log(e)
        }

        if (synchro_type_id === 1) {
            greenRef.current.classList.add(s.shake);
            setTimeout(() => {
                greenRef.current.classList.remove(s.shake);
            }, 200);
        } else if (synchro_type_id === 2) {
            yellowRef.current.classList.add(s.shake);
            setTimeout(() => {
                yellowRef.current.classList.remove(s.shake);
            }, 200);
        } else {
            redRef.current.classList.add(s.shake);
            setTimeout(() => {
                redRef.current.classList.remove(s.shake);
            }, 200);
        }

    }

    useEffect(() => {
        if (status !== 'wait') {
            setOpenModal(false)
        }
    }, [status])

    const keyPress = useCallback(
        async (e) => {
            if (e.repeat) return;

            if (e.key === '3') {
                await handlerClick(
                    data.find((f) => f.synchro_type_id === 1)?.score_synchro_id,
                    0.1,
                    1
                );
            } else if (e.key === '2') {
                await handlerClick(
                    data.find((f) => f.synchro_type_id === 2)?.score_synchro_id,
                    0.5,
                    2
                );
            } else if (e.key === '1') {
                await handlerClick(
                    data.find((f) => f.synchro_type_id === 3)?.score_synchro_id,
                    3,
                    3
                );
            }
        },
        [data]
    );

    useEffect(() => {
        document.addEventListener('keydown', keyPress)

        return () => {
            document.removeEventListener('keydown', keyPress)
        }
    },)

    return (
        <div className={s.synch}>
            <Header disabled={data?.length === 0 || !data} headerData={headerData}
                    openModal={() => setOpenModal(true)}/>

            {(data?.length === 0 || !data) ? <Empty/> : <div className={s.wrapper}>
                <div className={s.result_total}>
                    <p>Итого</p>
                    <div>{total.toFixed(2)}</div>
                </div>
                <div className={s.content}>
                    <div className={s.result_value}>
                        <div className={s.result_item}>
                            {data?.at(0)?.value?.toFixed(2)}
                        </div>
                        <div className={s.result_item}>
                            {data?.at(2)?.value?.toFixed(2)}
                        </div>
                        <div className={s.result_item}>
                            {data?.at(1)?.value?.toFixed(2)}
                        </div>
                    </div>
                    <div className={s.line}/>
                    <div className={s.result_tools}>
                        <div ref={greenRef} className={classNames(s.result_tools_item, s.green)}
                             onClick={() => handlerClick(data.find((f) => f.synchro_type_id === 1)?.score_synchro_id, 0.1, 1)}>0.1
                        </div>

                        <div ref={redRef} className={classNames(s.result_tools_item, s.red)}
                             onClick={() => handlerClick(data.find((f) => f.synchro_type_id === 3)?.score_synchro_id, 3, 3)}>3
                        </div>

                        <div ref={yellowRef} className={classNames(s.result_tools_item, s.yellow)}
                             onClick={() => handlerClick(data.find((f) => f.synchro_type_id === 2)?.score_synchro_id, 0.5, 2)}>0.5
                        </div>
                    </div>
                    <div className={s.line}/>
                    <div className={s.result_value}>
                        <div className={classNames(s.result_item)}>
                            {data?.at(0)?.value && (data?.at(0)?.value?.toFixed(2) / 0.1).toFixed(0)}
                        </div>
                        <div className={classNames(s.result_item)}>
                            {data?.at(2)?.value && (data?.at(2)?.value?.toFixed(2) / 3).toFixed(0)}
                        </div>
                        <div className={classNames(s.result_item)}>
                            {data?.at(1)?.value && (data?.at(1)?.value?.toFixed(2) / 0.5).toFixed(0)}
                        </div>
                    </div>
                </div>
            </div>}
            {openModal &&
                <ModalElement id={headerData?.competition_application_discipline_id} token={token} confirm={confirm}
                              setPage={setPage} open={openModal} onClose={() => setOpenModal(false)}
                              data={data} newData={newData} setNewData={setNewData} status={status}/>}
        </div>
    );
};

export default Synch;
